import { create } from 'zustand';

import { themeService } from '@/lib/api/themeService';
import type { Theme } from '@/types/theme';
import { API_CONFIG } from '@/constants/endpoints';

const DEFAULT_THEME: Theme = {
  name: 'default',
  title: 'Report Portal',
  images: {
    logo: '',
    logoMenu: '',
    logoMini: '',
    logoWhite: '',
    background: '',
    bgLogin: '',
  },
  customColors: {},
};

interface ThemeState {
  theme: Theme | null;
  isLoading: boolean;
  error: string | null;
  fetchTheme: () => Promise<void>;
}

export const useThemeStore = create<ThemeState>((set, get) => ({
  theme: null,
  isLoading: false,
  error: null,
  fetchTheme: async () => {
    if (get().isLoading) return;
    set({ isLoading: true, error: null });
    try {
      const theme = await themeService.getTheme();

      if (theme?.images) {
        const baseUrl = API_CONFIG.BASE_URL.startsWith('http')
          ? API_CONFIG.BASE_URL.split('/').slice(0, 3).join('/')
          : '';

        (Object.keys(theme.images) as Array<keyof typeof theme.images>).forEach(
          key => {
            const imagePath = theme.images[key];
            if (imagePath && !imagePath.startsWith('http')) {
              theme.images[key] =
                `${baseUrl}${imagePath.startsWith('/') ? '' : '/'}${imagePath}`;
            }
          },
        );
      }

      set({ theme, isLoading: false });
    } catch (error) {
      console.error('Theme fetch failed, using default theme', error);
      set({
        theme: DEFAULT_THEME,
        error: 'Failed to fetch theme',
        isLoading: false,
      });
    }
  },
}));
